<script lang="ts" setup>
  import { computed } from 'vue';
  import { Features } from '@shared/features';
  import { useUnitFormatter, Unit } from '@othercommerce/domain';
  import { useTranslator } from '@othercommerce/foundation';

  const props = defineProps({
    variant: { type: Object, required: true },
  });

  const translator = useTranslator();
  const unitFormatter = useUnitFormatter();

  const enabled = computed(() => {
    return Features.loyaltyPoints.isEnabled && props.variant.points > 0;
  });

  const unit = computed(() => {
    // TODO: Temporary variables to be replaced once units introduced to variants.
    let type = Unit.Piece;
    let value = 1;

    return unitFormatter.genitive(type, value);
  });

  const points = computed(() => {
    return translator.choice('SHOP.COMMON.MESSAGE.POINTS_COUNT', props.variant.points, { points: props.variant.points });
  });

  const message = computed(() => {
    return translator.trans('SHOP.COMMON.MESSAGE.POINTS_PER_UNIT', { unit: unit.value, points: points.value });
  });
</script>
<template>
  <div v-if="enabled" aria-live="polite" class="product-points">
    <SfIconCoin aria-hidden="true" class="product-points__icon" />
    <div class="product-points__obtainable" v-html="message" />
  </div>
</template>
<style lang="scss">
  @use "@storefront/styles/mixins/media";

  :root {
    --sf-points-gap: 0.5rem;
    --sf-points-icon-size: 0.875rem;
    --sf-points-font-size: 0.75rem;

    @include media.query(md) {
      --sf-points-icon-size: 0.875rem;
      --sf-points-font-size: 0.625rem;
    }
  }

  .product-points {
    display: flex;
    align-items: center;
    gap: var(--sf-points-gap);

    &__icon {
      flex: 0 0 var(--sf-points-icon-size);
      font-size: var(--sf-points-icon-size);
    }

    &__obtainable {
      font-size: var(--sf-points-font-size);
      line-height: 1.25;
    }
  }
</style>
